import Api from "@/services/Api";

export default {
  async academyClass(id, visitorId) {
    const response = await Api().get(
      "calendar/member/classes/" + id + (visitorId ? "?v=" + visitorId : "")
    );
    return response.data;
  },
  async leaveAcademyClass(id, member) {
    const response = await Api().patch(
      "calendar/member/classes/" + id + "/leave",
      { member: member }
    );
    return response.data;
  },
  async cancelRequest(id) {
    const response = await Api().patch(
      "calendar/member/classes/" + id + "/request/cancel"
    );
    return response.data;
  },
  async joinAcademyClass(id, member) {
    const response = await Api().patch(
      "calendar/member/classes/" +
        id +
        "/join" +
        (member ? "?member=" + member : "")
    );
    return response.data;
  },
  async joinAcademyClassFromHome(id, data) {
    const response = await Api().patch(
      "calendar/member/classes/" + id + "/join",
      data
    );
    return response.data;
  },
  async acceptRequest(managedAcademyid, classid, memberid) {
    const response = await Api().patch(
      "calendar/admin/academy/" +
        managedAcademyid +
        "/classes/" +
        classid +
        "/accept/" +
        memberid
    );
    return response.data;
  },
  async rejectRequest(managedAcademyid, classid, memberid) {
    const response = await Api().patch(
      "calendar/admin/academy/" +
        managedAcademyid +
        "/classes/" +
        classid +
        "/reject/" +
        memberid
    );
    return response.data;
  },
  async upcomingEvents(today, dayOfWeek, includeCalendar = false, managedAcademyId) {
    const response = await Api().get(
      "calendar/member/upcoming?today=" + today + "&dayofweek=" + dayOfWeek + (includeCalendar ? "&calendar=yes" : "") +
        (managedAcademyId ? "&managedAcademyId=" + managedAcademyId : "")
    );
    return response.data;
  },
};
